"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keybase = void 0;
var types_1 = require("../types");
exports.keybase = {
    name: 'keybase',
    matches: [
        {
            match: '(https?://)?(www.)?keybase.io/({PROFILE_ID})/?', group: 3, type: types_1.TYPE_DESKTOP,
            pattern: 'https://keybase.io/{PROFILE_ID}'
        },
        { match: '({PROFILE_ID})', group: 1 },
    ]
};
